const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/uster/eCheckin/sections/components/metakat/EinweisenderArzt/EinweisenderArztField.tsx';
import React, { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { CIS4mMetaKatDropDown } from '@cistec/common_web/modules/CIS4m/components/CIS4mMetaKatDropDown';
import { useCIS4FormMetaKatData } from 'App/store/cis4m';
import { TextInput } from '@cistec/common_web/utils/intlUtils';
import { useIntl } from 'react-intl';

interface Props {
    label: TextInput;
    path: string;
    hidden?: boolean;
    required?: boolean;
}

export const EinweisenderArztField = forwardRef((props: Props, ref: any) => {
    const dropdownRef = useCIS4m(ref);
    const { locale } = useIntl();

    const hidden = props.hidden ?? false;
    const required = props.required ?? false;

    return (
        <CIS4mMetaKatDropDown
            ref={dropdownRef}
            label={props.label}
            path={props.path}
            pcode={'35e92653-3534-41ee-a1d1-4067a701a6f9'}
            valuePath="FKEY"
            labelPath={`CONTENT.Lang.${locale}`}
            hidden={hidden}
            required={required}
            dataHook={useCIS4FormMetaKatData}
        />
    );
});

EinweisenderArztField.displayName = 'EinweisenderArztField';
